import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-address-editor',
  templateUrl: './address-editor.component.html',
  styleUrls: ['./address-editor.component.css']
})
export class AddressEditorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
